/**
 * Shared MUI `sx` style fragments for the setup wizard. Kept as plain objects so
 * each step component stays small and visually consistent.
 */

export const sx = {
  root: {
    position: 'fixed',
    inset: 0,
    zIndex: 2000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bgcolor: '#f4f6f8',
    p: 2,
  },
  card: {
    width: '100%',
    maxWidth: 680,
    minHeight: 460,
    borderRadius: 3,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    px: 4,
    pt: 3,
    pb: 2,
    borderBottom: '1px solid',
    borderColor: 'divider',
  },
  logo: { height: 34, marginBottom: 8 },
  body: {
    px: 4,
    py: 3,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  footer: {
    px: 4,
    py: 2,
    borderTop: '1px solid',
    borderColor: 'divider',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  centerCol: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 2,
  },
};

export default sx;
